import BlackbirdHeader from '../../components/BlackbirdHeader'
import Navbar from '../../components/BlackbirdNavbar'
import BlackbirdSummary from'../../components/BlackbirdSummary'
import Footer from '../../components/BlackbirdFooter'

import './blackbird.css'

const Blackbird = () => {
  return (
    <>
    <Navbar/>
    <BlackbirdHeader/>
    <BlackbirdSummary/>
    <Footer/>
    </> 
  )
}

export default Blackbird